import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useRouter } from "../../../hooks/router";
import {
    add_channel_to_favourites,
    get_home,
    get_movie_info,
    get_related_movies,
    remember_time, remove_channel_from_favourites,
    get_movie_url, set_view_channels
} from "../../../server/requests";
import { translateWord, decrypt } from "../../Util/util";

import { GoogleIMA } from "../../GoogleAds/GoogleAds";

import './Player.scss'
import './IsProtected.scss'


import ControlsPlayerLive from "./ControlsPlayerLive/ControlsPlayerLive";
import ControlsPlayerMovie from "./ControlsPlayerMovie/ControlsPlayerMovie";
import Loading from "../../Loading/Loading";
import Hls from "hls.js";
import ErrorMessage from "../../AlertMessage/ErrorMessage";
import PremiumField from "../../pages_child/PremiumField/PremiumField";
import VerifyPIN from "../../SubUsers/VerifyPIN/VerifyPin";
import ErrorMessagePlayer from "./ErrorMessagePlayer/ErrorMessagePlayer";
import Modal from "../Modal/Modal";


var time_out_percent
var time_out_control
var time_out_play_live
var time_out_ads
var _count_channel_urls = 0

export default ({ network, isGuest }) => {

    const router = useRouter()
    const user = JSON.parse(decrypt('user', localStorage.getItem('user')))

    const refVideoPlayer = useRef()
    const refPlayer = useRef()
    const adTagUrl = useRef('')

    const [showArchive, setShowArchive] = useState(false)

    const [currentTime, setCurrentTime] = useState(0)
    const [duration, setDuration] = useState(0)
    const [valueProgress, setValProgress] = useState(0)
    const [valProgressNextEpisode, setValProgressNextEpisode] = useState(0)
    const [channels, setChannels] = useState([
        { id: 0, title: 'favourites', array: [] },
        { id: 1, title: 'all', array: [] },
    ])


    const [activeMedia, setActiveMedia] = useState('')
    const [idActiveMedia, setIdActiveMedia] = useState(null)
    const [episode, setEpisode] = useState('')

    const [playPause, setPlayPause] = useState(false)
    const [fullScreen, setFullScreen] = useState(false)
    const [showLoading, setShowLoading] = useState(false)
    const [resume, setResume] = useState(false)
    const [audioTracks, setAudioTracks] = useState([])
    const [activeAudioTrack, setActiveAudioTrack] = useState({})
    const [subtitles, setSubtitles] = useState([])
    const [activeSub, setActiveSub] = useState({})
    const [classVideo, setClassVideo] = useState('')
    const [showMessage, setShowMessage] = useState(false)
    const [errMessageEpg, setErrMessageEpg] = useState('')
    const [showErrMessageEpg, setShowErrMessageEpg] = useState(false)
    const [showProtectedField, setShowProtectedField] = useState(false)
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [needLogin, setNeedLogin] = useState(false)

    const [channelFavourite, setChannelFavourite] = useState(false)
    const [showPremium, setShowPremium] = useState({
        show: false,
        type: '',
        id: ''
    })
    const [hls, setHls] = useState(null)
    const [timeshift, setTimeshift] = useState(false)

    useEffect(() => {

        refVideoPlayer.current.addEventListener('ended', onEnded)
        refVideoPlayer.current.addEventListener('loadedmetadata', loadedMetaDataPlayer)

    }, [])

    useEffect(() => {

        setShowLoading(true)

        if (router.query.type === 'live') {
            _count_channel_urls = 0
            get_home({}, data => {
                let newArray = channels
                let active_channel

                for (let i = 0; i < data.length; i++) {

                    if (data[i].type === 'live_tv') {

                        if (data[i].title === "Favorite live tv") {

                            newArray[0].array = data[i].content

                        } else {

                            let x = data[i].content.find(el => el.id == router.query.id)
                            setActiveMedia(x)
                            active_channel = x
                            if (!x.canWatch) {
                                setShowLoading(false)
                                setShowPremium({
                                    show: true,
                                    id: x.id,
                                    type: 'live'
                                })
                                setShowProtectedField(false)
                            } else if (x.is_protected && (localStorage.getItem('disable_code') == 'true')) {
                                setShowProtectedField(true)
                            } else {
                                setShowProtectedField(false)
                                playerVideo(x.url)
                            }
                            newArray[1].array = data[i].content

                        }
                    }
                }
                let fav_channel = newArray[0].array.find(e => e.id == active_channel.id)
                if (fav_channel) setChannelFavourite(true)
                else setChannelFavourite(false)


                setChannels([...newArray])

            }, err => console.log(err))

        } else {

            get_movie_info({ id: router.query.id }, data => {
                setIdActiveMedia(data.id)
                setActiveMedia(data)

                if (localStorage.getItem('begin')) {
                    setCurrentTime(0)
                } else {
                    if (data.watched) {
                        setResume(true)
                        let _time = parseInt(data.watched.time)
                        setCurrentTime(_time)
                    } else {
                        setCurrentTime(0)
                    }
                }

                if (router.query.type != 'movie') {

                    let _episode

                    if (router.query.season != 'undefined') {

                        let _season = data.seasons.find(e => e.number == router.query.season);
                        _episode = _season.episodes.find(e => e.number == router.query.episode);

                        setEpisode(_episode)

                        if (!localStorage.getItem('begin') && _episode.watched) setCurrentTime(parseInt(_episode.watched.time))

                        else setCurrentTime(0)

                    } else {
                        router.history.goBack()
                        return
                    }
                    getUrlMovies('tv_show', data.id, _episode.id)

                } else {
                    getUrlMovies('movie', data.id)

                }

            }, err => console.trace(err))

            get_related_movies({ id: router.query.id }, data => { }, err => console.log(err))

        }

    }, [router.query])

    useEffect(() => {
        refVideoPlayer.current.addEventListener('timeupdate', timeUpdatePlayer)

        return () => refVideoPlayer?.current?.removeEventListener('timeupdate', timeUpdatePlayer)
    })

    useEffect(() => {
        document.addEventListener('keydown', keyDown)
        return () => document.removeEventListener('keydown', keyDown)
    }, [playPause, fullScreen]);

    const getUrlMovies = (type, movie_id, episode_id) => {
        const body = {

        }
        if (type == 'movie') {
            body.id = movie_id
        } else {
            body.id = movie_id
            body.episode_id = episode_id
        }
        get_movie_url(body, data => {
            playerVideo(data.stream_url || "")

        }, err => {
            setShowMessage(true)
            setShowLoading(false)

            clearTimeout(time_out_play_live)

            time_out_play_live = setTimeout(() => {
                router.history.goBack()
            }, 3000)

            setTimeout(() => {
                setShowMessage(false)
            }, 2500)
        })

    }

    const playerVideo = (url) => {

        // url = 'http://commondatastorage.googleapis.com/gtv-vdfsdideos-bucket/sample/BigBuckBunny.mp4'

        if (url.indexOf('.mp4') > -1) {
            refVideoPlayer.current.src = url

            if (refVideoPlayer.current.subtitleTracks && refVideoPlayer.current.subtitleTracks.length > 0) {
                setSubtitles(refVideoPlayer.current.subtitleTracks);
                setActiveSub(refVideoPlayer.current.subtitleTrack)
            }
            if (refVideoPlayer.current.audioTracks && refVideoPlayer.current.audioTracks.length > 0) {
                setActiveAudioTrack(refVideoPlayer.current.audioTrack)
                setAudioTracks(refVideoPlayer.current.audioTracks)
            }

            setShowLoading(false)
            return
        }

        if (Hls.isSupported()) {

            if (hls) hls.destroy();
            let _hls = new Hls();

            setHls(_hls)

            if (showErrorMessage) setShowErrorMessage(false)

            refVideoPlayer.current.addEventListener("mouseover", e => {
                setTimeout(function () {
                    document.body.style.cursor = "none";
                    window.addEventListener("mousemove", et => {
                        document.body.style.cursor = "default";
                    });
                }, 2000);
            });

            _hls.loadSource(url);
            _hls.attachMedia(refVideoPlayer.current);

            _hls.on(Hls.Events.AUDIO_TRACK_LOADED, function (err, data) {
                setSubtitles(_hls.subtitleTracks);
                setAudioTracks(_hls.audioTracks);
            })

            _hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, function (e, data) {
                setActiveAudioTrack(_hls.audioTrack);
                setActiveSub(_hls.subtitleTrack);

            });

            _hls.on(Hls.Events.SUBTITLE_TRACK_LOADED, function (e, data) {
                setSubtitles(_hls.subtitleTracks);
            });

            _hls.on(Hls.Events.SUBTITLE_TRACK_SWITCH, function (e, data) {
                setActiveSub(_hls.subtitleTrack);

            });

            refVideoPlayer.current.onerror = () => {
                console.log('error videooooooooo')
            }

            let active_channel = channels[1].array.find(e => e.id == router.query.id)

            // if(activeMedia){
            _hls.on(Hls.Events.ERROR, function (err, data) {
                if (data.type == "mediaError") {
                    document.getElementById('video_player').pause()
                    setPlayPause(true)
                } else {
                    set_other_url()
                }

            });

            const set_other_url = () => {

                if (active_channel && active_channel.channel_urls && active_channel.channel_urls.length) {

                    if (active_channel.channel_urls[_count_channel_urls]) playerVideo(active_channel.channel_urls[_count_channel_urls].url)

                    else err_message()

                } else {

                    err_message()

                }

                _count_channel_urls++

            }

            function err_message() {

                setShowMessage(true)
                setShowLoading(false)

                clearTimeout(time_out_play_live)

                time_out_play_live = setTimeout(() => {

                    if (router.query.id) {
                        if (router.history.location.pathname == '/player') {
                            if (router.query.type && router.query.type != 'live') {
                                router.history.goBack()
                            } else {
                                setShowErrorMessage(true)
                            }
                        }
                        else router.push(router.history.location.pathname)
                    }

                }, 3000)

                setTimeout(() => {
                    setShowMessage(false)
                }, 2500)

            }

        }

    }

    const post_remember_time = (type) => {

        let body

        if (type == 'movie') {

            body = {
                percent: (currentTime / duration) * 100,
                time: currentTime,
                movieId: idActiveMedia,
                type: 'movie'
            }

        } else {
            body = {
                percent: (currentTime / duration) * 100,
                time: currentTime,
                movieId: idActiveMedia,
                episodeId: episode.id,
                type: 'tv_show'
            }
        }

        if (body.percent != 'Infinity') {

            remember_time(body, data => { }, err => console.log(err))

        }

    }

    const onEnded = () => {
        if (router.query.type == 'tv_show') {
            document.getElementById('next_episode').click()
        } else {
            refVideoPlayer.current.pause()
            setPlayPause(!playPause)
        }
    }

    useEffect(() => {

        if (activeMedia && activeMedia.advertisements && activeMedia.advertisements.length) {

            let random_ads = activeMedia.advertisements[Math.floor(Math.random() * activeMedia.advertisements.length)]
            let _url_tag = random_ads.url

            if (random_ads.type == "IMA") adTagUrl.current = _url_tag

        } else if (activeMedia) {
            adTagUrl.current = ''
        }

    }, [activeMedia])

    const playAd = (_url) => {

        GoogleIMA.init({
            timeout: 0, // milliseconds
            adTagUrl: _url,
            adContainer: document.getElementById("add-container"),
            events: {
                onAdStarted: function () {
                    refVideoPlayer.current.pause()
                },
                onAdProgress: function (data) {
                    // console.log("ad progress", data.getAdData());
                    refVideoPlayer.current.pause()

                    clearTimeout(time_out_ads)
                    time_out_ads = setTimeout(() => {
                        GoogleIMA.destroy()
                        refVideoPlayer.current.play()
                    }, 2500)
                },
                onAdEnded: function () {
                    // console.log("ad ended");
                    clearTimeout(time_out_ads)
                    refVideoPlayer.current.play()

                },
                onAdError: function (err) {
                    refVideoPlayer.current.play()
                    // console.log("ad error", err);
                },
            }
        });

    }

    const loadedMetaDataPlayer = () => {

        localStorage.removeItem('begin')
        setShowLoading(false)

        window.onresize = resize

        if (adTagUrl.current) playAd(adTagUrl.current)

        if (router.query.type == 'live') {

            setTimeout(() => {

                let user = JSON.parse(decrypt('user', localStorage.getItem('user')))

                let body = {
                    sub_userId: user.id,
                    channelId: router.query.id,
                    device_id: localStorage.getItem('device_id')
                }

                set_view_channels({ body }, res => console.log(res, 'set_view_channel'))

            }, 60000);

        }
    }

    const resize = (e) => {
        if (!document.webkitIsFullScreen) {
            setFullScreen(false)
        }
    }

    const timeUpdatePlayer = () => {
        if (refVideoPlayer.current && refVideoPlayer.current.currentTime > 0) {
            try {
                if (resume) {
                    refVideoPlayer.current.currentTime = currentTime
                    setResume(false)
                }


                if (currentTime !== Math.round(refVideoPlayer.current.currentTime)) {
                    if (duration - currentTime < 60) {
                        let x = duration - 60
                        if (((currentTime - x) / 60) * 100 <= 100) {
                            setValProgressNextEpisode(((currentTime - x) / 60) * 100)
                        }
                    }
                    if (router.query.type != 'live' && currentTime % 15 === 0 && currentTime !== 0) {
                        post_remember_time(router.query.type)
                    }
                    setDuration(Math.round(refVideoPlayer.current.duration))
                    setCurrentTime(Math.round(refVideoPlayer.current.currentTime))
                    if (duration != 0) {
                        let percent = (currentTime / duration) * 100
                        setValProgress(percent)
                    }
                }

            } catch (e) { }
        }
    }

    const keyDown = (e) => {

        if (e.code === 'Space') btn_play_pause()

        else if (e.code === 'KeyF') btn_full_screen()

    }

    const change_handle_range = (e) => {
        console.log(e.target.value)
        refVideoPlayer.current.pause()

        setValProgress(e.target.value)
        let _current_time = Math.round(e.target.value) / 100 * duration

        clearTimeout(time_out_percent)
        time_out_percent = setTimeout(() => {
            refVideoPlayer.current.currentTime = _current_time
            refVideoPlayer.current.play()

        }, 500)

    }

    const btn_full_screen = () => {
        if (fullScreen === false) {
            full_screen()
            document.body.classList.add('full_screen_body')
        } else {
            document.body.classList.remove('full_screen_body')
            exit_full_screen()
        }

        setFullScreen(!fullScreen)
    }

    const full_screen = () => {
        if (refPlayer.current.requestFullscreen) {
            refPlayer.current.requestFullscreen();
        } else if (refPlayer.current.webkitRequestFullscreen) { /* Safari */
            refPlayer.current.webkitRequestFullscreen();
        } else if (refPlayer.current.msRequestFullscreen) { /* IE11 */
            refPlayer.current.msRequestFullscreen();
        }
    }

    const exit_full_screen = () => {

        if (document.exitFullscreen) document.exitFullscreen();

        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();

        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();

        else if (document.msExitFullscreen) document.msExitFullscreen();

    }

    const btn_play_pause = (e) => {
        e.stopPropagation()


        document.removeEventListener('keydown', keyDown)

        if (!playPause) document.getElementById('video_player').pause()

        else document.getElementById('video_player').play()

        setPlayPause(!playPause)

    }

    const btn_back_forward = (e) => {
        e.stopPropagation()

        if (refVideoPlayer.current.currentTime < 10) {

            setCurrentTime(0)
            refVideoPlayer.current.currentTime = 0

        } else {

            var percent
            var cur = refVideoPlayer.current.currentTime

            percent = Math.round(currentTime / duration * 100);
            setValProgress(percent)
            setCurrentTime(prev => prev - 10)
            refVideoPlayer.current.currentTime = cur - 10

        }

    }

    const btn_forward = (e) => {
        e.stopPropagation()

        if (refVideoPlayer.current.duration - refVideoPlayer.current.currentTime < 10) {
            setCurrentTime(Math.round(refVideoPlayer.current.duration))
            refVideoPlayer.current.currentTime = refVideoPlayer.current.duration
        } else {
            var percent
            var cur = refVideoPlayer.current.currentTime

            percent = Math.round(currentTime / duration * 100);
            setValProgress(percent)
            setCurrentTime(prev => prev + 10)
            refVideoPlayer.current.currentTime = cur + 10
        }
    }

    const callBackArchiveEpg = (epg, channel) => {
        if (channel.archived_channel_host) {
            let start = epg.start_ut
            let end = epg.stop_ut

            let url = ''

            if (channel.cdn_url) {

                url = channel.cdn_url + '/archive/' + channel.id + '/index.m3u8'

            } else if (channel.archived_channel_host) {


                if (channel.archived_channel_host.indexOf('http') == -1) url = 'http://' + channel.archived_channel_host + '/archive/' + channel.id + '/index.m3u8'

                else url = channel.archived_channel_host + '/archive/' + channel.id + '/index.m3u8'

            }

            url = url + `?start=${start}&duration=${end - start}`

            playerVideo(url)
            setTimeshift(true)
            setShowArchive(true)

            // const body = {
            //     streamId: id,
            //     start: epg.start_ut,
            //     end: epg.stop_ut
            // }

            // requests('get', url, body, data => {
            //     playerVideo(data)
            //     setTimeshift(true)
            //     setShowArchive(true)
            // }, err => {
            //     setShowErrMessageEpg(true)
            //     setErrMessageEpg(err)
            //     hide_error_message()
            // })
        } else {
            //Archive
            setShowErrMessageEpg(true)
            setErrMessageEpg('Stream is not available now. please try after few minutes')
            hide_error_message()
        }
    }

    const btn_subtitle = (i) => {
        setActiveSub(i)
        hls.subtitleTrack = i
    }

    const btn_dubbing = (i) => {
        setActiveAudioTrack(i)
        hls.audioTrack = i
    }

    const mouse_movie_video = () => {
        if (!classVideo) {
            setClassVideo('show_control')
        }
    }

    const mouse_move_controls = () => {
        if (!classVideo) {
            setClassVideo('show_control')
        }
        clearTimeout(time_out_control)

        time_out_control = setTimeout(() => {
            setClassVideo('')
        }, 3000)
    }

    const btn_next_channel = (e) => {
        e.stopPropagation()

        let active_channel = channels[1].array.find(e => e.id == router.query.id)
        let next_live
        if ((channels[1].array.indexOf(active_channel) + 1) != channels[1].array.length) {
            next_live = channels[1].array[channels[1].array.indexOf(active_channel) + 1]
        } else {
            next_live = channels[1].array[0]
        }
        router.push('/player?type=live&id=' + next_live.id)
    }

    const btn_previous_channel = (e) => {
        e.stopPropagation()
        let active_channel = channels[1].array.find(e => e.id == router.query.id)
        let prev_live
        if ((channels[1].array.indexOf(active_channel) - 1) < 0) {
            prev_live = channels[1].array[channels[1].array.length - 1]
        } else {
            prev_live = channels[1].array[channels[1].array.indexOf(active_channel) - 1]
        }
        router.push('/player?type=live&id=' + prev_live.id)
    }

    const btn_next_episode = (e) => {
        e.stopPropagation()

        let id_movie = router.query.id
        let index_episode = 0
        let index_season = 0
        let active_season
        let active_episode
        let next_episode

        if (activeMedia.seasons && activeMedia.seasons.length) {
            active_season = activeMedia.seasons.find(e => e.number == router.query.season)
            index_season = activeMedia.seasons.indexOf(active_season)
            active_episode = active_season.episodes.find(e => e.number == router.query.episode)
            index_episode = active_season.episodes.indexOf(active_episode)
            index_episode++
            if (!active_season.episodes[index_episode]) {
                index_season++
                if (activeMedia.seasons[index_season]) {
                    index_episode = 0
                    next_episode = activeMedia.seasons[index_season].episodes[index_episode]
                } else {
                    return
                }
            } else {
                next_episode = active_season.episodes[index_episode]
            }
            setEpisode(next_episode)
        }
        router.push(
            `/player?type=tv_show&id=${id_movie}&season=${activeMedia.seasons[index_season].number}&episode=${next_episode.number}`
        )
    }

    const btn_previous_episode = (e) => {
        e.stopPropagation()

        let id_movie = router.query.id
        let index_episode = 0
        let index_season = 0
        let active_season
        let active_episode
        let prev_episode

        if (activeMedia.seasons && activeMedia.seasons.length) {
            active_season = activeMedia.seasons.find(e => e.number == router.query.season)
            index_season = activeMedia.seasons.indexOf(active_season)
            active_episode = active_season.episodes.find(e => e.number == router.query.episode)
            index_episode = active_season.episodes.indexOf(active_episode)
            index_episode--
            if (!active_season.episodes[index_episode]) {
                index_season--
                if (activeMedia.seasons[index_season]) {
                    index_episode = activeMedia.seasons[index_season].episodes.length - 1
                    prev_episode = activeMedia.seasons[index_season].episodes[index_episode]
                } else {
                    return
                }
            } else {
                prev_episode = active_season.episodes[index_episode]
            }
            setEpisode(prev_episode)
        }


        router.push(`/player?type=tv_show&id=${id_movie}&season=${activeMedia.seasons[index_season].number}&episode=${prev_episode.number}`)
    }

    const btn_add_remove_favourites = () => {
        let body = {
            subId: user.type == 'root_account' ? '0' : user.id,
            channel_id: router.query.id
        }
        let newArray = channels
        let channel

        if (channelFavourite) {

            remove_channel_from_favourites(body, data => {
                channel = newArray[0].array.find(e => e.id == router.query.id)
                let indexChannel = newArray[0].array.indexOf(channel)
                newArray[0].array.splice(indexChannel, 1)

                setChannelFavourite(false)
            }, err => {
                setShowErrMessageEpg(true)
                setErrMessageEpg(err)
                hide_error_message()
            })

        } else {
            add_channel_to_favourites(body, data => {
                channel = channels[1].array.find(e => e.id == router.query.id)
                newArray[0].array.push(channel)
                setChannelFavourite(true)
            }, err => {
                setShowErrMessageEpg(true)
                setErrMessageEpg(err)
                hide_error_message()
            })

        }

        setChannels([...newArray])
    }

    const show_time_shift = () => {

        if (activeMedia.cdn_url) {
            let _url = activeMedia.cdn_url + '/timeshift/' + activeMedia.id + '/index.m3u8'
            playerVideo(_url)
            setTimeshift(!timeshift)
            setShowArchive(false)
        } else if (activeMedia.archived_channel_host) {
            let _url = ''
            if (activeMedia.archived_channel_host.indexOf('http') == -1) _url = 'http://' + activeMedia.archived_channel_host + '/timeshift/' + activeMedia.id + '/index.m3u8'
            else _url = activeMedia.archived_channel_host + '/timeshift/' + activeMedia.id + '/index.m3u8'
            playerVideo(_url)
            setTimeshift(!timeshift)
            setShowArchive(false)
        } else {
            //timeshift not found
            setShowErrMessageEpg(true)
            setErrMessageEpg('Stream is not available now. please try after few minutes')
            hide_error_message()
        }
    }

    const hide_error_message = () => {
        setTimeout(() => {
            setShowErrMessageEpg(false)
        }, 3000)
    }

    const callBackIsProtected = (id) => {
        let active_live = channels[1].array.find(e => e.id == id)

        playerVideo(active_live.url)
    }

    const btnConfirmLogIn = () => {
        localStorage.setItem('showLogin', true)
        router.push('/auth')
    }

    const btnCancelLogIn = () => {
        router.history.goBack()
    }


    return (
        <>

            {showErrorMessage ? <ErrorMessagePlayer /> : null}
            <ErrorMessage text={errMessageEpg} type={'warning'} show={showErrMessageEpg} />

            <ErrorMessage text={
                'Stream is not available now. please try after few minutes'}
                type={'error'} show={showMessage} />

            <div className="container player">
                <div id="player" ref={refPlayer} className={classVideo}>
                    {showProtectedField ?
                        isGuest ?

                            ReactDOM.createPortal(
                                <Modal
                                    btnConfirm={() => {
                                        localStorage.setItem('showLogin', true)
                                        router.push('/auth')
                                    }}
                                    btnCancel={() => {
                                        router.history.goBack()
                                        setShowPremium(false)
                                    }}
                                    btnConfirmText={translateWord('Sign in')}
                                    btnCancelText={translateWord('Cancel')}
                                    title={translateWord('Sign in to continue')}
                                />, document.body)
                            :
                            <div className="is_protected_field">
                                <VerifyPIN user={user} callBackIsProtected={callBackIsProtected}
                                    setShowProtectedField={setShowProtectedField} />
                            </div>
                        : null}
                    {showPremium.show ?
                        isGuest ?
                            ReactDOM.createPortal(
                                <Modal
                                    btnConfirm={() => {
                                        localStorage.setItem('showLogin', true)
                                        router.push('/auth')
                                    }}
                                    btnCancel={() => {
                                        router.history.goBack()
                                        setShowPremium(false)
                                    }}
                                    btnConfirmText={translateWord('Sign in')}
                                    btnCancelText={translateWord('Cancel')}
                                    title={translateWord('Sign in to continue')}
                                />, document.body)
                            :
                            ReactDOM.createPortal(<PremiumField
                                id={showPremium.id}
                                type={showPremium.type}
                                close={() => {

                                    router.push(`/settings?a=payment&content_id=${activeMedia.id}${(activeMedia.type == 'tv_show' || activeMedia.type == 'movie' ? '&content_type=vod' : '')}`)
                                    setShowPremium({
                                        show: false,
                                        id: '',
                                        type: ''
                                    })
                                }}
                            />, document.body)

                        : null}
                    <div id="controls" onMouseMove={mouse_move_controls} onDoubleClick={btn_full_screen}>

                        {

                            network && fullScreen ?
                                <div className="errorConnectionPlayer">
                                    <h2>Error</h2>
                                    <h1>Your device may not connected to the Internet.Please make sure your
                                        connection is working.</h1>
                                </div>
                                :
                                <>
                                    {showLoading ?
                                        <Loading /> : null}
                                    {router.query.type == "live" ?
                                        <ControlsPlayerLive
                                            isGuest={isGuest}
                                            showErrorMessage={showErrorMessage}
                                            showArchive={showArchive}
                                            timeshift={timeshift}
                                            show_time_shift={show_time_shift}
                                            btn_add_remove_favourites={btn_add_remove_favourites}
                                            channelFavourite={channelFavourite}
                                            btn_next_channel={btn_next_channel}
                                            btn_previous_channel={btn_previous_channel}
                                            callBackArchiveEpg={callBackArchiveEpg}
                                            currentTime={currentTime}
                                            duration={duration}
                                            channels={channels}
                                            activeMedia={activeMedia}
                                            playPause={playPause}
                                            btn_play_pause={btn_play_pause}
                                            change_handle_range={change_handle_range}
                                            valueProgress={valueProgress}
                                            fullScreen={fullScreen}
                                            btn_full_screen={btn_full_screen}
                                            btn_forward={btn_forward}
                                            btn_back_forward={btn_back_forward}

                                        /> :
                                        <ControlsPlayerMovie
                                            btn_previous_episode={btn_previous_episode}
                                            btn_next_episode={btn_next_episode}
                                            valProgressNextEpisode={valProgressNextEpisode}
                                            activeAudioTrack={activeAudioTrack}
                                            activeSub={activeSub}
                                            audioTracks={audioTracks}
                                            subtitles={subtitles}
                                            episode={episode}
                                            btn_forward={btn_forward}
                                            movie={activeMedia}
                                            btn_back_forward={btn_back_forward}
                                            currentTime={currentTime}
                                            duration={duration}
                                            playPause={playPause}
                                            btn_play_pause={btn_play_pause}
                                            change_handle_range={change_handle_range}
                                            valueProgress={valueProgress}
                                            fullScreen={fullScreen}
                                            btn_full_screen={btn_full_screen}
                                            btn_subtitle={btn_subtitle}
                                            btn_dubbing={btn_dubbing}
                                        />}
                                </>
                        }
                    </div>
                    <video
                        autoPlay
                        onMouseMove={mouse_movie_video}
                        id={'video_player'}
                        ref={refVideoPlayer}
                        onDoubleClick={btn_full_screen}
                    ></video>

                    <div id="add-container" ></div>

                </div>
            </div>
        </>
    )
}